import { apiService, saveAuthData, clearAuthData } from './api';
import { LoginCredentials, RegisterData, ClienteProfile } from '@/types/auth';

export const authApi = {
  // Verificar status de autenticação
  checkAuth: () => apiService.get('/auth/check'),

  // Login
  login: async (credentials: LoginCredentials) => {
    const response = await apiService.post('/auth/login', credentials);
    if (response.data.success && response.data.token) {
      saveAuthData(response.data.token, response.data.user);
    }
    return response.data;
  },

  // Registro
  register: (data: RegisterData) => 
    apiService.post('/auth/register', data),

  // Logout
  logout: async () => {
    try {
      await apiService.post('/auth/logout');
    } finally {
      clearAuthData();
    }
    return { success: true };
  },

  // Atualizar perfil do usuário
  updateProfile: (data: Partial<ClienteProfile>) => 
    apiService.put('/auth/profile', data),

  // Completar perfil do cliente
  completeClienteProfile: (data: ClienteProfile) => 
    apiService.post('/auth/complete-profile', data),
};
